//StyledCharacterModal__closeButton
export module CharacterModalModule {
  export class Service {
    //private StyledCharacterModal: NodeListOf<HTMLElement> | undefined;

    constructor() {
      const StyledCharacterModal = document.querySelectorAll('.StyledCharacterModal');
      if (StyledCharacterModal) {
        document.addEventListener('readCompleteAction', () => {
          this.setEvent();
        })
      }
    }

    private setEvent() {
      const StyledCharacterModal = document.querySelectorAll('.StyledCharacterModal');
      StyledCharacterModal?.forEach(StyledCharacterModal => {
        const StyledCharacterModal__closeButton = StyledCharacterModal.querySelector('.StyledCharacterModal__closeButton') as HTMLElement;
        if (StyledCharacterModal__closeButton) {
          StyledCharacterModal__closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            console.log('click');

            // StyledCharacterModal に　data-scroll があれば、スクロール位置を戻す
            const scrollPosition = StyledCharacterModal.getAttribute('data-scroll');
            if (scrollPosition) {
              window.scrollTo({
                top: Number(scrollPosition),
              });
            }
            // StyledCharacterModal から　data-scroll を削除する
            StyledCharacterModal.classList.remove('is-open');
            // body から　is-modal-open を削除する
            const body = document.querySelector('body');
            body?.classList.remove('is-modal-open');
          });
        }
      });
    }
  }
}
